import React from 'react';
import { useStyletron } from 'baseui';
import CXReportAttachments from './CXReportAttachments';
import NPReportAttachments from './NPReportAttachments';
export default ({
  isNP
}) => {
  const [css] = useStyletron();
  return <section className={css({
    margin: '32px 0',
    display: 'flex',
    flexFlow: 'column',
    gap: '24px'
  })}>
      {isNP ? <NPReportAttachments /> : <CXReportAttachments />}
    </section>;
};